var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { SectionMenu } from '../question-sets/section-menu/section-menu';
import { Button, Container, PageHeading } from '../../../components/shared';
import { formTypeName, services, SystemRules, isTrue, pageContentValues } from '../../../shared';
import { CaseNavigation } from '../case-navigation/case-navigation';
import { AddFees, FeeType } from './add-fees/add-fees';
import { useHistory } from 'react-router';
import '../question-sets/question-sets.scss';
import './fees.scss';
import { FormType } from '../../../shared/types/enums';
import { useWorkflowStore } from '../../store/workflowStore';
export var Fees = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var pages = _a.pages, steps = _a.steps, rootPath = _a.rootPath, location = _a.location, workflowName = _a.workflowName, caseId = _a.caseId, formId = _a.formId;
    var _h = useState(false), menuVisible = _h[0], toggleMenuVisibility = _h[1];
    var _j = useState([]), fees = _j[0], setFees = _j[1];
    var _k = useState(false), isWorldPayProviderActive = _k[0], setIsWorldPayProviderActive = _k[1];
    var _l = useState(false), isMandatoryFees = _l[0], setIsMandatoryFees = _l[1];
    var _m = useState(''), mandatoryFeeDescription = _m[0], setMandatoryFeeDescription = _m[1];
    var _o = useState(), nextPage = _o[0], setNextPage = _o[1];
    var history = useHistory();
    var removeWorkflow = useWorkflowStore(function (state) { return state.removeWorkflowStore; });
    var reloadGrids = function (caseId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = setFees;
                    return [4 /*yield*/, services.getFees(caseId, formId)];
                case 1:
                    _a.apply(void 0, [(_b.sent()).data]);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isMandatory, _a, _b, _c;
        var _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    reloadGrids(caseId, formId);
                    _a = isTrue;
                    return [4 /*yield*/, services.getSystemRule(SystemRules.madatoryFees)];
                case 1:
                    isMandatory = _a.apply(void 0, [(_f.sent()).data]);
                    setIsMandatoryFees(isMandatory);
                    if (!(!isMandatory && (mandatoryFeeDescription === null || mandatoryFeeDescription === void 0 ? void 0 : mandatoryFeeDescription.length) == 0)) return [3 /*break*/, 3];
                    _b = setMandatoryFeeDescription;
                    return [4 /*yield*/, services.getModuleText(pageContentValues.fees.nonMandatory)];
                case 2:
                    _b.apply(void 0, [(_e = (_d = (_f.sent()).data) === null || _d === void 0 ? void 0 : _d.description) !== null && _e !== void 0 ? _e : '']);
                    _f.label = 3;
                case 3:
                    _c = setIsWorldPayProviderActive;
                    return [4 /*yield*/, services.isWorldPayProviderActive()];
                case 4:
                    _c.apply(void 0, [(_f.sent()).data]);
                    return [2 /*return*/];
            }
        });
    }); };
    var saveSectionEvent = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.UpdateFeePageViewed(caseId, formId)];
                case 1:
                    _a.sent();
                    if (!((activeStep === null || activeStep === void 0 ? void 0 : activeStep.formType) == FormType[FormType.Illustration].toString())) return [3 /*break*/, 3];
                    return [4 /*yield*/, services.submitApplication(caseId, formId)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    removeWorkflow();
                    history.push(nextPage.path, location.state);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (caseId > 0 && formId > 0 && fees.length === 0)
            fetchData();
    }, [caseId, formId]);
    var activeStep = steps === null || steps === void 0 ? void 0 : steps.find(function (step) { return step.isActive; });
    var feesToAddToLoan = fees === null || fees === void 0 ? void 0 : fees.filter(function (f) { return f.isAddedToLoan && !f.isPaid; });
    var feesOnApplication = fees === null || fees === void 0 ? void 0 : fees.filter(function (f) { return !f.selected && (f.payableOn === 'On Application' || f.payableOn === 'On Completion'); });
    return (React.createElement("div", { className: "l-question-sets" },
        React.createElement("div", { className: "l-question-sets__toggle-menu" },
            React.createElement(Button, { type: "button", variant: "navy", icon: "chevronRight", iconPosition: "right", onClick: function () { return toggleMenuVisibility(!menuVisible); } }, "Open Steps")),
        React.createElement("div", { className: "l-question-sets__content" },
            React.createElement("div", { className: "l-question-sets__menu ".concat(menuVisible && 'isActive') },
                React.createElement(SectionMenu, { pages: pages, rootPath: rootPath, location: location, workflowName: workflowName, closeMenu: toggleMenuVisibility })),
            React.createElement("div", { className: "l-question-sets-anchor-bg" }),
            React.createElement("div", { className: "l-question-sets__questions" },
                React.createElement("div", { className: "l-question-sets__header" },
                    React.createElement(PageHeading, { headingLevel: 2, title: 'Fees', icon: workflowName === null || workflowName === void 0 ? void 0 : workflowName.toLowerCase(), mb: 6 })),
                React.createElement(Container, { ctabar: true },
                    React.createElement("div", { className: "c-question-set c-form-fee-tables" },
                        React.createElement(AddFees, { caseId: (_d = (_c = (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.case) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : Number(caseId), form: activeStep, heading: 'Fees that can be added to the loan amount', noRowsMessage: "No fees can be added to this loan", feeType: FeeType.AddToLoan, feeData: feesToAddToLoan, reloadGrids: reloadGrids }),
                        React.createElement(AddFees, { caseId: (_g = (_f = (_e = location === null || location === void 0 ? void 0 : location.state) === null || _e === void 0 ? void 0 : _e.case) === null || _f === void 0 ? void 0 : _f.id) !== null && _g !== void 0 ? _g : Number(caseId), feeData: feesOnApplication, heading: "Fees to pay ".concat((activeStep === null || activeStep === void 0 ? void 0 : activeStep.formType) == formTypeName.illustration ? 'on application/completion' : 'now'), noRowsMessage: 'No fees to pay now', feeType: (activeStep === null || activeStep === void 0 ? void 0 : activeStep.formType) == formTypeName.illustration ? FeeType.PayOnApplication : FeeType.PayableNow, form: activeStep, reloadGrids: reloadGrids, allowPayNow: isMandatoryFees && isWorldPayProviderActive && (activeStep === null || activeStep === void 0 ? void 0 : activeStep.formType) != formTypeName.illustration, noPayNowDescription: mandatoryFeeDescription }),
                        React.createElement(CaseNavigation, { pages: pages, workflowSteps: steps, location: location, onNextClick: saveSectionEvent, setTargetPage: setNextPage })))))));
};
